module.exports = __webpack_public_path__ + "static/media/urdu_novel_bank_logo.8932b974.png";